import { Icon }      from "@chakra-ui/react";
import { IconProps } from "@chakra-ui/react";

const EntityIcon = (props: IconProps) => {
	return (
		<Icon {...props}>
			<svg viewBox="0 -960 960 960">
				<path fill="currentColor" d="M120-120v-560h160v-160h400v320h160v400H520v-160h-80v160H120Zm80-80h80v-80h-80v80Zm0-160h80v-80h-80v80Zm0-160h80v-80h-80v80Zm160 160h80v-80h-80v80Zm0-160h80v-80h-80v80Zm0-160h80v-80h-80v80Zm160 320h80v-80h-80v80Zm0-160h80v-80h-80v80Zm0-160h80v-80h-80v80Zm160 480h80v-80h-80v80Zm0-160h80v-80h-80v80Z"/>
			</svg>
		</Icon>
	)
}

export default EntityIcon;
